import { ADDITIONAL_FIELDS_API } from "components/helper/callApi";

type Params = {
    shouldCountOnlineDevice?: boolean;
    fields?: ADDITIONAL_FIELDS_API[];
};

export const getAdditionalFields = (params: Params) => {
    const { shouldCountOnlineDevice, fields } = params;

    const additionalFields = new Set<ADDITIONAL_FIELDS_API>(); //Using set in order to prevent doubles

    additionalFields.add(ADDITIONAL_FIELDS_API.PROXIES);
    additionalFields.add(ADDITIONAL_FIELDS_API.IS_SIGNED);
    additionalFields.add(ADDITIONAL_FIELDS_API.IS_PHOTO_RECEIVED);

    if (shouldCountOnlineDevice) {
        additionalFields.add(ADDITIONAL_FIELDS_API.LIVE_DEVICE_COUNT);
    }

    if (fields?.length) {
        fields.forEach((field) => additionalFields.add(field));
    }

    return Array.from(additionalFields);
};
